import { EyeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import Widget from '../../widget';
import { useChartHelper } from './helper';
import Style from './style';

function Base({
  data: unsortedData = [],
  getRedirectLink = () => { },
}) {
  const { t } = useTranslation();
  const ref = useRef();

  const data = useMemo(() => {
    const beforeData = unsortedData.sort((a, b) => (b.contribution || 0) - (a.contribution || 0));
    if (beforeData.length > 4) {
      const fourAndMore = beforeData.splice(4);
      let sum = 0;
      fourAndMore.forEach((s) => sum += s.contribution);
      return [...beforeData.splice(0, 4), {
        label: t('Other'),
        sources: fourAndMore,
        contribution: sum,
      }];
    }

    return beforeData;
  }, [unsortedData, t]);

  const {
    activeIndex,
    setActiveIndex,
  } = useChartHelper({ ref, sources: data }, t);

  return (
    <Style>
      <div ref={ref} style={{ position: 'relative', height: 500, maxHeight: 500 }} />
      <div className="legend">
        {data.map((d, i) => (
          <div
            onMouseEnter={() => setActiveIndex(i)}
            onMouseLeave={() => setActiveIndex(null)}
            className={formatClassname([
              'item',
              activeIndex === i && 'active',
              (typeof activeIndex === 'number' && activeIndex !== i) && 'disabled',
            ])}
            key={`legend-item-${i + 1}`}
          >
            <div className="section">
              <label>{t(d.label)}</label>
            </div>
            {(!!!d.sources && d.id) && (
              <div className="section">
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  to={getRedirectLink(d.id)}
                >
                  <Button icon={<EyeOutlined className="mt-1" />} size="small" type="ghost"></Button>
                </Link>
              </div>
            )}
          </div>
        ))}

      </div>
    </Style>
  );
}

export default function SourceContributions({ 
  data,
  getRedirectLink = () => { },
  loading,
}) {
  const { t } = useTranslation();
  return (
    <Widget
      title={t('Assessment Contributions')}
      className="custom-width"
      loading={loading}
    >
      {loading ? null : (
        <Base data={data} getRedirectLink={getRedirectLink} />
      )}
    </Widget>
  );
}
